// import React from "react";
// import '../Home/Home.css';
// import { useTranslation } from 'react-i18next';
// import imagemSetor_en from '../../assets/setores-chave_en.png';
// import imagemSetor_pt from '../../assets/setores-chave_pt.png';
// import pt_download from '/planilhas/Component2.xlsx';
// import en_download from '/planilhas/Componente2.xlsx';

// const Comp2 = () => {
//   const { t, i18n } = useTranslation();
//   return (
//     <>

//     <div className='text-container'>
//         <h3 className='title-home'>{t('comp2-title')}</h3>
//         <p>{t('comp2-text-1')}</p>
//         <img 
//           className='imagem-centralizada' 
//           src={i18n.language === 'en' ? imagemSetor_en : imagemSetor_pt} 
//           alt={t('sector-home')} 
//         />
//         <p>{t('comp2-text-2')}</p>
//         <p>{t('comp2-text-3')}</p>
//         <p>{t('comp2-text-4')}</p>
//         <p>{t('comp2-text-5')}<a 
//   href={i18n.language === 'en' ? en_download : pt_download }
//   download
//   target="_blank" 
//   rel="noopener noreferrer"
// >
//   link
// </a>
//   </p>
       
//     </div>

//     </>
//   );
// };

// export default Comp2;


import React from "react";
import '../Home/Home.css';
import { useTranslation } from 'react-i18next';
import imagemSetor_en from '../../assets/setores-chave_en.png';
import imagemSetor_pt from '../../assets/setores-chave_pt.png';

const Comp2 = () => {
  const { t, i18n } = useTranslation();

  const isEnglish = i18n.language.startsWith('en');

  return (
    <div className='text-container'>
      <h3 className='title-home'>{t('comp2-title')}</h3>

      <p>{t('comp2-text-1')}</p>

      <img
        className='imagem-centralizada'
        src={isEnglish ? imagemSetor_en : imagemSetor_pt}
        alt={t('sector-home')}
      />

      <p>{t('comp2-text-2')}</p>
      <p>{t('comp2-text-3')}</p>
      <p>{t('comp2-text-4')}</p>

      <p>
        {t('comp2-text-5')}

        <a
          href={
            isEnglish
              ? "/Component2.xlsx"
              : "/Componente2.xlsx"
          }
          download
          target="_blank"
          rel="noopener noreferrer"
        >
          {" "}link
        </a>
      </p>
    </div>
  );
};

export default Comp2;